import { render, staticRenderFns } from "./ITextArea.vue?vue&type=template&id=21e596ea&scoped=true&"
import script from "./ITextArea.vue?vue&type=script&lang=js&"
export * from "./ITextArea.vue?vue&type=script&lang=js&"
import style0 from "./ITextArea.vue?vue&type=style&index=0&id=21e596ea&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e596ea",
  null
  
)

export default component.exports